import { render, staticRenderFns } from "./profile-activity-details.vue?vue&type=template&id=fa505580&scoped=true&"
import script from "./profile-activity-details.ts?vue&type=script&lang=ts&"
export * from "./profile-activity-details.ts?vue&type=script&lang=ts&"
import style0 from "./profile-activity-details.scss?vue&type=style&index=0&id=fa505580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa505580",
  null
  
)

export default component.exports